module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification"
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('div', {
      key: index
    }, [(notification.visible && notification.title) ? _c('div', {
      ref: notification.id,
      refInFor: true,
      staticClass: "toast add-margin",
      class: _vm.classes(notification)
    }, [_c('div', {
      staticClass: "toast__icon"
    }, [(notification.type == 'info') ? _c('div', [_vm._m(0, true)]) : (notification.type == 'error') ? _c('div', [_vm._m(1, true)]) : (notification.type == 'success') ? _c('div', [_vm._m(2, true)]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "toast__content"
    }, [_c('p', {
      staticClass: "toast__type"
    }, [_vm._v(_vm._s(_vm.$t(notification.title)))])]), _vm._v(" "), _c('div', {
      staticClass: "toast__close",
      on: {
        "click": function($event) {
          return _vm.close(notification)
        }
      }
    }, [_c('i', {
      staticClass: "icon yule-icon-close-small"
    })])]) : _vm._e()])
  }), 0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-container"
  }, [_c('i', {
    staticClass: "icon yule-icon-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-container"
  }, [_c('i', {
    staticClass: "icon yule-icon-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-container"
  }, [_c('i', {
    staticClass: "icon yule-icon-success"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0609f1e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/Notification.vue
// module id = 1800
// module chunks = 0